import { render, staticRenderFns } from "./SunBlind.vue?vue&type=template&id=6824ca2c&scoped=true&"
import script from "./SunBlind.vue?vue&type=script&lang=js&"
export * from "./SunBlind.vue?vue&type=script&lang=js&"
import style0 from "./SunBlind.vue?vue&type=style&index=0&id=6824ca2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6824ca2c",
  null
  
)

export default component.exports